import slugify from 'slugify'

export const getProductSlug = ({ id, title }: { id: number; title: string }) =>
  `${slugify(title, { lower: true, strict: true })}-p${id}`

export const getVariantSlug = ({ id, title }: { id: number; title: string }) =>
  `${slugify(title, { lower: true, strict: true })}-v${id}`
